import { FC } from 'react'
import { StyleProp, StyleSheet, Text, TextStyle } from 'react-native'
import { FontsEnum } from '../../../constants/fonts'

interface IngredientItemProps {
    children: string
    color?: string
    style?: StyleProp<TextStyle>
}

const IngredientItem: FC<IngredientItemProps> = ({ children, color, style }) => {
    return <Text style={[styles.text, color ? { color } : false, style]}>{children}</Text>
}

const styles = StyleSheet.create({
    text: {
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 16,
        paddingVertical: 2,
        paddingHorizontal: 6,
    },
})

export default IngredientItem
